import React, { useState } from 'react';
import { DatatableWrapper, TableBody, TableHeader } from 'react-bs-datatable';
import { Col, Row, Table } from 'react-bootstrap';
import DropIcon from '../../assets/images/right-more.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import './tableContent.css';

// Import Material UI components
import Pagination from '@mui/material/Pagination';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#6B7A99', // Custom primary color
    },
    secondary: {
      main: '#f44336', // Secondary color remains the same
    },
  },
});

const TableContent = ({
  tableData,
  header,
  isPagination = true,
  onPageChange,
  currentPage,
  pageCount,
}) => {
  const [expandedRow, setExpandedRow] = useState(null);
  const toggleRow = rowIndex => {
    setExpandedRow(prev => (prev === rowIndex ? null : rowIndex));
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="table-container-dashboard">
        <DatatableWrapper
          body={tableData?.length > 0 ? tableData : []}
          headers={header}
        >
          <Table>
            <thead>
              <tr>
                {header.map(h => (
                  <th key={h.prop}>{h.title}</th>
                ))}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tableData?.length > 0 ? (
                tableData?.map((row, index) => (
                  <React.Fragment key={index}>
                    <tr>
                      {header.map(h => (
                        <td key={h.prop}>{row[h.prop]}</td>
                      ))}
                      <td>
                        <button
                          className="arrowDrop"
                          onClick={() => toggleRow(index)}
                        >
                          {expandedRow === index ? (
                            <div className="arrowUp">
                              <img src={DropIcon} alt="" />
                            </div>
                          ) : (
                            <div className="arrowDown">
                              <img src={DropIcon} alt="" />
                            </div>
                          )}
                        </button>
                      </td>
                    </tr>
                    <tr className="commentSectionBar">
                      <td colSpan={header.length + 1} className="comment-row">
                        <div
                          className={`comment-container commentHeading ${
                            expandedRow === index ? 'expanded' : ''
                          }`}
                        >
                          <h4>Comments</h4>
                          {row.comment}
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                ))
              ) : (
                <tr class="tbody-tr">
                  <td class="tbody-td" colspan="6">
                    No results to be shown.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {isPagination && tableData?.length > 0 && (
            <Row>
              <Col
                lg={12}
                className="pagination-container"
                style={{ display: 'flex', justifyContent: 'end' }}
              >
                <Pagination
                  count={pageCount}
                  page={currentPage}
                  onChange={(event, value) => onPageChange(value)}
                  showFirstButton
                  showLastButton
                  shape="rounded"
                  color="primary"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      color: '#636E72',
                    },
                    '& .Mui-selected': {
                      backgroundColor: '#6B7A99',
                      color: 'white',
                    },
                  }}
                />
              </Col>
            </Row>
          )}
        </DatatableWrapper>
      </div>
    </ThemeProvider>
  );
};

export default TableContent;
